<template>
  <div class="app-input">
    <label :for="id" class="label">
      {{ label }}
      <span v-if="isRequired">*</span>
    </label>
    <input
      :id="id"
      @input="updateSelf($event.target.value)"
      @change="onChange($event)"
      ref="input"
      :value="model"
      :type="type"
      :disabled="disabled"
      :placeholder="placeholder || label"
      :class="{ invalid: errors && errors.length, ...classes }"
      :maxlength="maxlength"
    />
    <div v-if="errors && errors.length" class="error">{{ errors[0] }}</div>
  </div>
</template>

<script>
export default {
  name: 'app-input',
  model: {
    prop: 'model',
    event: 'input',
  },
  props: [
    'label',
    'placeholder',
    'type',
    'classes',
    'disabled',
    'control',
    'mask',
    'model',
    'errors',
    'maxlength',
    'required',
  ],
  methods: {
    updateSelf(value) {
      this.$emit('input', value);
    },
    onChange(event) {
      this.$emit('change', event);
    },
    focus() {
      this.$refs.input.focus();
    },
  },
  computed: {
    id() {
      return `app-input-${this.label}`;
    },
    invalid() {
      return this.control
        ? this.control.$invalid && this.control.$dirty
        : false;
    },
    isRequired() {
      return this.required === '' || this.required;
    },
  },
  watch: {
    model(newValue) {
      this.updateSelf(newValue);
    },
  },
};
</script>

<style lang="scss" scoped>
.app-input {
  margin: 12px 0;

  label {
    display: block;
    text-transform: uppercase;
    font-size: 0.9em;
    margin-bottom: 3px;
    font-weight: 400;

    > span {
      color: var(--color-danger);
      font-size: 0.9em;
      position: relative;
      top: -3px;
      left: -2px;
    }
  }

  input {
    border: 1px solid #ddd;
    outline: 0;
    padding: 8px;
    border-radius: 4px;
    width: 100%;
    height: 38px;
    font-size: 1em;
    color: #424242;
    transition: box-shadow 0.1s ease-in-out;

    &::placeholder {
      color: #bbb;
    }

    &:focus {
      box-shadow: 0 0 15px -5px lightgrey;
    }
  }

  .error {
    font-size: 0.8em;
    color: #ff6363;
  }
}
</style>
